// extracted by mini-css-extract-plugin
export default {"question":"styles_question__C7dwT","title":"styles_title__1rhjr","desktop":"styles_desktop__9YzqS","answers":"styles_answers__veSpI"};